import { hsMakeDefaultLights } from '../../../engine-new/functions/make-default-lights.function';
import { HsLightStorage } from '../../../engine-new/storages/light-storage.class';
import type { HsVisualQualitySettings } from '../../types/visual-quality-settings.interface';
import type { HsShaderData } from '../classes/shader-data.class';

export function hsApplyVisualQualityToShader(
  shaderData: HsShaderData,
  settings: HsVisualQualitySettings
): HsShaderData {
  const needsNormals: boolean =
    settings.shadingMode === 'diffuse' || settings.specularEnabled || settings.fresnelEnabled;
  if (needsNormals) {
    shaderData.addNormals();
  }
  shaderData.setLightStorage(
    new HsLightStorage(hsMakeDefaultLights(settings.ambientIntensity, settings.directionalIntensity))
  );
  if (settings.shadingMode === 'diffuse') {
    shaderData.addDiffuseLighting();
  }
  if (settings.specularEnabled && settings.specularIntensity > 0) {
    shaderData.addSpecularLighting(4, settings.specularIntensity);
  }
  if (settings.fresnelEnabled && settings.fresnelIntensity > 0) {
    shaderData.addFresnel(settings.fresnelIntensity);
  }
  if (settings.exposure !== 0 || settings.contrast !== 1) {
    shaderData.addColorGrading(settings.exposure, settings.contrast);
  }
  return shaderData;
}
